import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChecklistCard = ({ item, onNavigate }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const priorityColors = {
    high: 'text-error',
    medium: 'text-warning',
    low: 'text-muted-foreground'
  };

  const priorityBgColors = {
    high: 'bg-error/10',
    medium: 'bg-warning/10',
    low: 'bg-muted/10'
  };

  return (
    <div className={`bg-card border rounded-lg p-6 transition-smooth hover:shadow-elevation-2 ${
      item?.completed ? 'border-success/50 bg-success/5' : 'border-border'
    }`}>
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-start gap-3 flex-1">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
            item?.completed ? 'bg-success/20 text-success' : 'bg-primary/10 text-primary'
          }`}>
            {item?.completed ? (
              <Icon name="CheckCircle2" size={24} />
            ) : (
              <Icon name={item?.icon} size={24} />
            )}
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="text-lg font-semibold text-foreground">
                {item?.title}
              </h3>
              {item?.completed && (
                <span className="px-2 py-0.5 bg-success/20 text-success text-xs font-medium rounded">
                  Completed
                </span>
              )}
            </div>
            <p className="text-sm text-muted-foreground">
              {item?.description}
            </p>
          </div>
        </div>
      </div>

      {/* Metadata */}
      <div className="flex items-center gap-4 mb-4 text-sm">
        <div className="flex items-center gap-1.5 text-muted-foreground">
          <Icon name="Clock" size={14} />
          <span>{item?.estimatedTime}</span>
        </div>
        <div className={`flex items-center gap-1.5 px-2 py-1 rounded ${priorityBgColors?.[item?.priority]}`}>
          <Icon name="Flag" size={14} className={priorityColors?.[item?.priority]} />
          <span className={`capitalize ${priorityColors?.[item?.priority]}`}>
            {item?.priority} priority
          </span>
        </div>
      </div>

      {/* Expandable Tasks */}
      {!item?.completed && (
        <div className="mb-4">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="flex items-center gap-2 text-sm font-medium text-primary hover:text-primary/80 transition-smooth"
          >
            <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={16} />
            <span>{isExpanded ? 'Hide' : 'Show'} tasks ({item?.tasks?.length})</span>
          </button>
          
          {isExpanded && (
            <ul className="mt-3 space-y-2">
              {item?.tasks?.map((task, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Icon name="Circle" size={12} className="mt-1 flex-shrink-0" />
                  <span>{task}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

      {/* Action Button */}
      <Button
        onClick={onNavigate}
        variant={item?.completed ? 'outline' : 'default'}
        fullWidth
        iconName={item?.completed ? 'Eye' : 'ArrowRight'}
        iconPosition="right"
      >
        {item?.completed ? 'Review' : 'Start Setup'}
      </Button>
    </div>
  );
};

export default ChecklistCard;